import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import { useParams, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import { WidgetFooter, WidgetHeader } from "../../widgets";
import AnimatedLoader from "../../modules/ui/animatedLoader";
import ModalEditProfile from "../../modules/ui/Modals/ModalEditProfile";
import ModalSetting from "../../modules/ui/Modals/ModalSetting";
import {
  CLOSE_MODAL_AUTH,
  MODAL_TOGGLE,
  NEW_USER_MODAL,
} from "../../store/Modal/Modal.constant";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ModalAuth from "../../modules/ui/Modals/ModalAuth";
import ModalConfirmation from "../../modules/ui/Modals/ModalСonfirmation";
import ModalGroupSetting from "../../modules/ui/Modals/ModalGroupSettings";
import DeliveryControlPanelCard from "./DeliveryControlPanelCard";
import { GROUP_ORDER_ADMIN_DASHBOARD_AUTH } from "../../store/Form/Form.constant";

const DeliveryControlPanel = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const { slug_uuid } = useParams();
  const common = useSelector((state) => state.common);
  const modals = useSelector((store) => store.modal[slug_uuid]);
  const form = useSelector((state) => state.form);
  const groupOrders = common.groupOrders?.[slug_uuid];
  const isJoin = true;
  const settings = common.settings?.[slug_uuid];
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const adminToken = query.get("token");

  useEffect(() => {
    if (adminToken) {
      dispatch({
        type: GROUP_ORDER_ADMIN_DASHBOARD_AUTH,
        payload: {
          user_id: slug_uuid,
          token: adminToken
        }
      });
    }
  }, [slug_uuid, adminToken]);

  useEffect(() => {
    if (settings?.auth?.is_dashboard_admin && adminToken) {
      history.replace(`/grouporder-dashboard/${slug_uuid}/delivery-control-panel`);
    }
  }, [settings?.auth?.is_dashboard_admin, slug_uuid, adminToken]);


  useEffect(() => {
    if (settings?.auth?.auth_token !== token) {
      dispatch({ type: NEW_USER_MODAL, payload: slug_uuid });
    }
  }, []);
  return (
    <>
      <AnimatedLoader />
      <WidgetHeader
        user_id={slug_uuid}
        isJoin={isJoin}
        auth={settings?.auth}
        creator_id={slug_uuid}
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Delivery Control Panel</title>
        <meta id="meta-description" name="description" content={"njjn"} />
      </Helmet>
      {modals?.isModalAuth ? (
        <ModalAuth
          user_id={slug_uuid}
          error={form.form?.error?.message}
          show={modals.isModalAuth}
          onHide={() =>
            dispatch({ type: CLOSE_MODAL_AUTH, payload: slug_uuid })
          }
        />
      ) : null}
      <ToastContainer progressClassName="fancy-progress-bar" />
      {modals?.isModalConfirmation ? (
        <ModalConfirmation
          user_id={slug_uuid}
          isResendCode={settings?.isResendCode}
          error={form.form?.error?.message}
          show={modals.isModalConfirmation}
          order_deadline={groupOrders?.order_deadline * 1000}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalConfirmation", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalEditProfile ? (
        <ModalEditProfile
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalEditProfile}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalEditProfile", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalSetting ? (
        <ModalSetting
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalSetting}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalSetting", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalGroupSetting ? (
        <ModalGroupSetting
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalGroupSetting}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalGroupSetting", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      <div className="delivery-control-panel-container">
        <h2 className="delivery-control-panel-title">Delivery Control Panel</h2>
        <p>Control when employees are notified to pick up their meals</p>
        <div className="delivery-control-panel-card">
          <DeliveryControlPanelCard
            user_id={slug_uuid}
          />
        </div>
      </div>
      <WidgetFooter />
    </>
  );
};

export default DeliveryControlPanel;
